<template>
  <v-card>
    <v-progress-linear color="blue" indeterminate v-if="loading"></v-progress-linear>
    <v-card-title class="grey lighten-4 py-4 title">
      Import results: {{eventName}}
    </v-card-title>
    <v-container grid-list-sm class="pa-4">
      <v-layout row wrap>
        <v-flex xs9>
          <v-text-field prepend-icon="notes" placeholder="Results URL" disabled :value="resultsurl"></v-text-field>
        </v-flex>
        <v-flex xs3>
          <v-btn @click="importResults" color="success" v-if="isRunBritainRankings" :disabled="loading">IMPORT</v-btn>
          <v-btn @click="preValidation" color="success">validate</v-btn>
          <v-icon color="success" v-if="isValid">check_circle</v-icon>
        </v-flex>
        <v-flex xs12 v-if="existingResults">
          <v-alert type="warning" v-model="existingResults">
            Warning, this event has already imported result.
            <v-btn @click="deleteResults" color="warning">DELETE EXISTING RESULTS?</v-btn>
          </v-alert>
        </v-flex>
        <v-flex xs12>
          <v-alert type="error" dismissible v-model="hasErrors">
            Validation error: {{ this.validationErrors }}
          </v-alert>
        </v-flex>
        <v-flex xs12 fluid>
          <v-textarea box height="220px" label="Formatted data:" v-model="dataToImport" hint="Should be the data either imported automatically or taken from an excel spreadsheet and pasted in."></v-textarea>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>


<script>
import * as apiEvents from "@/api/events";
import moment from "moment";
import fb from "@/firebaseConfig";

export default {
  props: ["value", "eventName", "eventId", "resultsurl"],
  data: () => ({
    loading: false,
    existingResults: false,
    dataToImport: "",
    validationErrors: "",
    hasErrors: false,
    isValid: false
  }),
  mounted() {},
  methods: {
    importResults() {
      this.loading = true;

      apiEvents
        .autoimport(this.eventId, this.resultsurl)
        .then(e => {
          this.dataToImport = e.results;
        })
        .catch(apiEvents.handleError)
        .finally(() => {
          this.loading = false;
        });
    },
    deleteResults() {
      this.loading = true;
      apiEvents
        .deleteEventResults(this.eventId)
        .then(() => {
          this.existingResults = false;
        })
        .catch(apiEvents.handleError)
        .finally(() => {
          this.loading = false;
        });
    },
    preValidation() {
      this.loading = true;

      this.existingResults = false;
      apiEvents
        .validateResults(this.eventId, this.dataToImport)
        .then(res => {
          if (res.isvalid) {
            return true;
          } else {
            return Promise.reject(res.error.errorMessage);
          }
        })
        .then(() => {
          return apiEvents.getEvent(this.eventId).then((e)=>{
            this.existingResults = e.hasresults;
            return;
          });
        })
        .then(() => {
          this.hasErrors = false;
          this.isValid = true;
          return true;
        })
        .catch(error => {
          this.hasErrors = true;
          this.isValid = false;
          this.validationErrors = error;
        })
        .finally(() => {
          this.loading = false;
          this.$emit("importValiation", this.isValid, this.dataToImport);
        });
    }
  },
  computed: {
    isRunBritainRankings() {
      if (
        this.resultsurl.includes("resultsbase.net") ||
        this.resultsurl.includes("stuweb.co.uk") ||
        this.resultsurl.includes("runbritainrankings.com")
      )
        return true;
      else return false;
    }
  },

  components: {}
};
</script>